import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PublicLayout } from '../components/PublicLayout';
import { Alert, Button, Field } from '../components/ui';
import { ApiError, api } from '../services/api';

export function ForgotPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await api.forgotPassword(email.trim());
      setDone(email.trim());
    } catch (err) {
      setError(err instanceof ApiError && err.is('rate_limited') ? t('app.rateLimited') : t('app.error'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <PublicLayout title={t('forgot.title')} subtitle={t('forgot.subtitle')}>
      {done ? (
        <Alert kind="success">{t('forgot.done', { email: done })}</Alert>
      ) : (
        <form onSubmit={submit} className="flex flex-col gap-3" noValidate>
          <Field id="email" label={t('auth.email')} type="email" autoComplete="username" placeholder={t('auth.emailPlaceholder')} value={email} onChange={(e) => setEmail(e.target.value)} required />
          {error && <Alert kind="error">{error}</Alert>}
          <Button type="submit" disabled={busy || !email.trim()} className="w-full">
            {busy ? t('forgot.sending') : t('forgot.send')}
          </Button>
        </form>
      )}
      <Link to="/login" className="text-center text-[12.5px] text-muted underline hover:text-ink">
        {t('forgot.backToLogin')}
      </Link>
    </PublicLayout>
  );
}
